import { SectionsHeroParallax, SectionProps } from "../../../types";
import {
  heroParallaxVariants,
  HeroParallaxVariantProps,
} from "./hero-parallax.variants";

export type HeroParallaxImage = {
  id: string;
  src: string;
  depth: number;
  className?: string;
  wrapperClassName?: string;
  width: number;
  height: number;
};

export type UseHeroParallaxProps = SectionProps<
  SectionsHeroParallax,
  HeroParallaxVariantProps
>;

export const useHeroParallax = (props: UseHeroParallaxProps) => {
  const { className = "", sectionName, data } = props;
  const imagesBase = data.images;
  const styles = heroParallaxVariants();

  const images: HeroParallaxImage[] = [
    {
      id: "1",
      depth: 0.5,
      src: imagesBase[0]?.url as string,
      wrapperClassName:
        "top-[8%] left-[15%] lg:top-[8%] lg:left-[24%] xl:top-[-2%] xl:left-[20%] 2xl:top-[5%] 2xl:left-[30%]",
      className:
        "w-[130px] h-[100px] sm:w-[195px] sm:h-[150px] 2xl:w-[260px] 2xl:h-[200px] 4xl:w-[390px] 4xl:h-[300px] object-cover",
      width: imagesBase[0]?.width as number,
      height: imagesBase[0]?.height as number,
    },
    {
      id: "2",
      depth: 1,
      src: imagesBase[1]?.url as string,
      wrapperClassName: "top-[15%] left-[52%] lg:top-[10%] lg:left-[66%]",
      className:
        "w-[130px] h-[100px] sm:w-[195px] sm:h-[150px] 2xl:w-[260px] 2xl:h-[200px] 4xl:w-[390px] 4xl:h-[300px] object-cover",
      width: imagesBase[1]?.width as number,
      height: imagesBase[1]?.height as number,
    },
    {
      id: "3",
      depth: 2,
      src: imagesBase[2]?.url as string,
      wrapperClassName:
        "xxs:hidden sm:block top-[22%] left-[90%] lg:top-[20%] lg:left-[90%]",
      className:
        "w-auto h-[80px] sm:w-[82px] sm:h-[120px] 2xl:w-[109px] 2xl:h-[160px] 4xl:w-[165px] 4xl:h-[240px] object-cover",
      width: imagesBase[2]?.width as number,
      height: imagesBase[2]?.height as number,
    },
    {
      id: "4",
      depth: 0.5,
      src: imagesBase[3]?.url as string,
      wrapperClassName: "top-[35%] right-[-20%] lg:top-[45%] lg:right-[5%]",
      className:
        "w-[130px] h-[100px] sm:w-[195px] sm:h-[150px] 2xl:w-[260px] 2xl:h-[200px] 4xl:w-[390px] 4xl:h-[300px] object-cover",
      width: imagesBase[3]?.width as number,
      height: imagesBase[3]?.height as number,
    },
    {
      id: "5",
      depth: -1.5,
      src: imagesBase[4]?.url as string,
      wrapperClassName:
        "bottom-[22%] right-[13%] lg:bottom-[25%] lg:right-[35%]",
      className:
        "w-[130px] h-[100px] sm:w-[195px] sm:h-[150px] 2xl:w-[260px] 2xl:h-[200px] 4xl:w-[390px] 4xl:h-[300px] object-cover",
      width: imagesBase[4]?.width as number,
      height: imagesBase[4]?.height as number,
    },
    {
      id: "6",
      depth: 1,
      src: imagesBase[5]?.url as string,
      wrapperClassName:
        "bottom-[18%] left-[32%] lg:bottom-[30%] lg:left-[30%] 3xl:bottom-[20%] 3xl:left-[40%] 4xl:bottom-[20%] 4xl:left-[40%]",
      className:
        "w-[55px] h-[80px] sm:w-[82px] sm:h-[120px] 2xl:w-[115px] 2xl:h-[160px] 4xl:w-[165px] 4xl:h-[240px] object-cover",
      width: imagesBase[5]?.width as number,
      height: imagesBase[5]?.height as number,
    },
    {
      id: "7",
      depth: 1,
      src: imagesBase[6]?.url as string,
      wrapperClassName:
        "top-[32%] left-[-8%] lg:top-[26%] lg:left-[10%] 2xl:top-[26%] 2xl:left-[-1%] 3xl:top-[28%] 3xl:left-[12%] 4xl:top-[28%] 4xl:left-[12%]",
      className:
        "w-[100px] h-[80px] sm:w-[150px] sm:h-[120px] 2xl:w-[200px] 2xl:h-[160px] 4xl:w-[300px] 4xl:h-[240px] object-cover",
      width: imagesBase[6]?.width as number,
      height: imagesBase[6]?.height as number,
    },
    {
      id: "8",
      depth: 0.8,
      src: imagesBase[7]?.url as string,
      wrapperClassName:
        "top-[50%] left-[-10%] lg:top-[48%] lg:left-[2%] 2xl:top-[48%] 2xl:left-[2%] 3xl:top-[51%] 3xl:left-[15%] 4xl:top-[51%] 4xl:left-[8%]",
      className:
        "w-[100px] h-[80px] sm:w-[150px] sm:h-[120px] 2xl:w-[200px] 2xl:h-[160px] 4xl:w-[300px] 4xl:h-[240px] object-cover",
      width: imagesBase[7]?.width as number,
      height: imagesBase[7]?.height as number,
    },
  ];

  return {
    className,
    styles,
    sectionName,
    data,
    images,
  };
};
